import { parseAbi } from "viem";

/**
 * Human-readable ABI for WizardCollection. Keep in sync with
 * packages/contracts/contracts/WizardCollection.sol.
 */
export const collectionAbi = parseAbi([
  "function mintPublic(uint256 quantity) payable",
  "function mintAllowlist(uint256 quantity, bytes32[] proof) payable",
  "function phase() view returns (uint8)",
  "function mintPrice() view returns (uint256)",
  "function allowlistPrice() view returns (uint256)",
  "function maxPerWallet() view returns (uint256)",
  "function totalSupply() view returns (uint256)",
  "function maxSupply() view returns (uint256)",
  "function mintedBy(address) view returns (uint256)",
  "function revealed() view returns (bool)",
  "function tokenURI(uint256 tokenId) view returns (string)",
]);

export const PHASES = ["Closed", "Allowlist", "Public"] as const;
